var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 2.25,
    fill: "#EF8918",
    stroke: "#F5A736",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.39551C8.51992 3.41663 8.55049 3.45296 8.59082 3.5166C8.70675 3.69955 8.83803 3.98586 9.03418 4.41797L9.49121 5.42578C9.59282 5.64964 9.67719 5.83442 9.75586 5.98047C9.83599 6.12923 9.92342 6.26322 10.0439 6.375C10.2488 6.56491 10.5046 6.68578 10.7783 6.71875L10.8965 6.72754C11.0627 6.73191 11.2165 6.69318 11.3701 6.63867C11.5197 6.58556 11.6966 6.50726 11.9062 6.41406C12.1563 6.30295 12.3215 6.23032 12.4434 6.18848C12.5012 6.16864 12.5342 6.16092 12.5498 6.1582C12.5767 6.17127 12.6114 6.20238 12.626 6.2627C12.6229 6.24971 12.6336 6.28011 12.5928 6.42676C12.5542 6.56556 12.4878 6.75117 12.3887 7.02539L11.5547 9.33398C11.3736 9.83499 11.2466 10.1841 11.1211 10.4443C10.9988 10.6978 10.8937 10.8318 10.7744 10.9209C10.6578 11.008 10.5134 11.0626 10.2646 11.0928C10.0045 11.1243 9.66908 11.125 9.17773 11.125H7.82227C7.33092 11.125 6.99549 11.1243 6.73535 11.0928C6.48659 11.0626 6.34219 11.008 6.22559 10.9209C6.10633 10.8318 6.00118 10.6978 5.87891 10.4443C5.75339 10.1841 5.62634 9.83499 5.44531 9.33398L4.61133 7.02539C4.51225 6.75116 4.44585 6.56556 4.40723 6.42676C4.36646 6.28023 4.37708 6.24978 4.37402 6.2627C4.38846 6.20297 4.42245 6.17152 4.44922 6.1582C4.4644 6.16079 4.4976 6.16822 4.55664 6.18848C4.67852 6.23032 4.84375 6.30295 5.09375 6.41406C5.30343 6.50726 5.48026 6.58556 5.62988 6.63867C5.78347 6.69318 5.93727 6.73191 6.10352 6.72754C6.42147 6.71917 6.72201 6.592 6.95605 6.375C7.07661 6.26322 7.16401 6.12923 7.24414 5.98047C7.3228 5.83442 7.40718 5.64963 7.50879 5.42578L7.96582 4.41797C8.16197 3.98586 8.29325 3.69955 8.40918 3.5166C8.44951 3.45295 8.48008 3.41663 8.5 3.39551Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13H11",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdated);
export default __webpack_public_path__ + "static/media/updated.4d91d5d9622121bfb6e2b3e869395021.svg";
export { ForwardRef as ReactComponent };